import { DocumentMaster } from "./DocumentMaster.model";
import { PredefinedMaster } from "./PredefinedMaster.model";
import { UserDocument } from "./UserDocument.model";
import { UserOtherDetails } from "./UserOtherDetails.model";

export class User {
  public id: number;
  public username: String;
  public password: String;
  public otp: string;
  public actualOtp: string;
  public newPassword: string;
  public currentPassword: String;
  public confirmPassword: String;
  public isNewRegistration: Boolean;
  public phone: number;
  public email: String;
  public name: string;
  public referralCode: string;

  public dob: Date;

  public qualification: string;
  public experience: string;
  public appUniqueId: string;
  public firebaseToken: string;

  public user: User;
  // public lattitude:string;
  // public longitude:string;
  // public roles:Role[];
  // public roleId:number;
  // public currentBatchId:number;
  // public currentPassword:string;
  // public parent:UserLogin;
  // public parentId:number;
  // public newPassword:string;
  // public confirmPassword:string;

  // public entityType:string;
  // public actualOTP:number;
  // public userOTP:number;
  // public errorMessage:string;
  // public studentId:number;

  // public isNewRegistration:Boolean;
  // public userLogoPath: string;
  // public fullname:string;
  // public role:Role;
  public pageNumber: number;
  public pageSize: number;
  public userImageList: UserDocument[] = [];
  public resumeDocument: DocumentMaster;

  public educationQualificationList: UserOtherDetails[] = [];
  public workExperienceList: UserOtherDetails[] = [];
  public designationList: UserOtherDetails[] = [];
  public deviceType: string;
  public address: string;
  public description: string;
  public gender: string;
  public dobStr: string;
  public genderPredefinedTemp: PredefinedMaster;
  public gstNo: string;
}
